'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024 from "./app.data.-General-Practice-User-Permission$.js";
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024$002dRemove$002dUser from "./app.data.-General-Practice-User-Permission$-Remove-User.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserRole$namedEnum$() {
  this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_byName = null;
  this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_values$lzy1 = null;
  this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_valuesbitmap$1 = false;
  $n_Lapp_data_GeneralPracticeUserRole$namedEnum$ = this;
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_data_GeneralPracticeUserRole$namedEnum$ as $c_Lapp_data_GeneralPracticeUserRole$namedEnum$ };
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.constructor = $c_Lapp_data_GeneralPracticeUserRole$namedEnum$;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserRole$namedEnum$() {
}
export { $h_Lapp_data_GeneralPracticeUserRole$namedEnum$ as $h_Lapp_data_GeneralPracticeUserRole$namedEnum$ };
$h_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype = $c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype;
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.byName__sci_Map = (function() {
  return this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_byName;
});
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.framework$utils$NamedEnum$_setter_$byName_$eq__sci_Map__V = (function(x$0) {
  this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_byName = x$0;
});
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.toName__Lapp_data_GeneralPracticeUserRole__T = (function(a) {
  var x = $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole();
  if ((x === a)) {
    return "owner";
  }
  var x$3 = $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole();
  if ((x$3 === a)) {
    return "member";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.values__sci_Vector = (function() {
  if ((!this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_valuesbitmap$1)) {
    var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().wrapRefArray__AO__scm_ArraySeq$ofRef($m_Lapp_data_GeneralPracticeUserRole$().values__ALapp_data_GeneralPracticeUserRole());
    this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_values$lzy1 = $x_1.fromVectorUnsafe__sci_Vector__sci_Vector($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().from__sc_IterableOnce__sci_Vector(this$2));
    this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_valuesbitmap$1 = true;
  }
  return this.Lapp_data_GeneralPracticeUserRole$namedEnum$__f_values$lzy1;
});
$c_Lapp_data_GeneralPracticeUserRole$namedEnum$.prototype.toName__O__T = (function(a) {
  return this.toName__Lapp_data_GeneralPracticeUserRole__T(a);
});
var $d_Lapp_data_GeneralPracticeUserRole$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserRole$namedEnum$, "app.data.GeneralPracticeUserRole$namedEnum$", ({
  Lapp_data_GeneralPracticeUserRole$namedEnum$: 1,
  Lframework_utils_NamedEnum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserRole$namedEnum$ as $d_Lapp_data_GeneralPracticeUserRole$namedEnum$ };
var $n_Lapp_data_GeneralPracticeUserRole$namedEnum$;
function $m_Lapp_data_GeneralPracticeUserRole$namedEnum$() {
  if ((!$n_Lapp_data_GeneralPracticeUserRole$namedEnum$)) {
    $n_Lapp_data_GeneralPracticeUserRole$namedEnum$ = new $c_Lapp_data_GeneralPracticeUserRole$namedEnum$();
  }
  return $n_Lapp_data_GeneralPracticeUserRole$namedEnum$;
}
export { $m_Lapp_data_GeneralPracticeUserRole$namedEnum$ as $m_Lapp_data_GeneralPracticeUserRole$namedEnum$ };
function $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole() {
  $m_Lapp_data_GeneralPracticeUserRole$();
  return $t_Lapp_data_GeneralPracticeUserRole$__Owner;
}
export { $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole as $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole };
function $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole() {
  $m_Lapp_data_GeneralPracticeUserRole$();
  return $t_Lapp_data_GeneralPracticeUserRole$__Member;
}
export { $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole as $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserRole$() {
  this.Lapp_data_GeneralPracticeUserRole$__f_$values = null;
  this.Lapp_data_GeneralPracticeUserRole$__f_schema$lzy1 = null;
  this.Lapp_data_GeneralPracticeUserRole$__f_schemabitmap$1 = false;
  this.Lapp_data_GeneralPracticeUserRole$__f_circeCodec$lzy1 = null;
  this.Lapp_data_GeneralPracticeUserRole$__f_circeCodecbitmap$1 = false;
  $n_Lapp_data_GeneralPracticeUserRole$ = this;
  $t_Lapp_data_GeneralPracticeUserRole$__Owner = new $c_Lapp_data_GeneralPracticeUserRole$$anon$1("Owner", 0);
  $t_Lapp_data_GeneralPracticeUserRole$__Member = new $c_Lapp_data_GeneralPracticeUserRole$$anon$1("Member", 1);
  this.Lapp_data_GeneralPracticeUserRole$__f_$values = new ($d_Lapp_data_GeneralPracticeUserRole.getArrayOf().constr)([$s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole(), $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole()]);
}
export { $c_Lapp_data_GeneralPracticeUserRole$ as $c_Lapp_data_GeneralPracticeUserRole$ };
$c_Lapp_data_GeneralPracticeUserRole$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserRole$.prototype.constructor = $c_Lapp_data_GeneralPracticeUserRole$;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserRole$() {
}
export { $h_Lapp_data_GeneralPracticeUserRole$ as $h_Lapp_data_GeneralPracticeUserRole$ };
$h_Lapp_data_GeneralPracticeUserRole$.prototype = $c_Lapp_data_GeneralPracticeUserRole$.prototype;
$c_Lapp_data_GeneralPracticeUserRole$.prototype.values__ALapp_data_GeneralPracticeUserRole = (function() {
  var this$1 = this.Lapp_data_GeneralPracticeUserRole$__f_$values;
  return this$1.clone__O();
});
$c_Lapp_data_GeneralPracticeUserRole$.prototype.schema__Lsttp_tapir_Schema = (function() {
  if ((!this.Lapp_data_GeneralPracticeUserRole$__f_schemabitmap$1)) {
    var this$1 = $m_Lapp_data_GeneralPracticeUserRole$namedEnum$();
    this.Lapp_data_GeneralPracticeUserRole$__f_schema$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__schema__Lsttp_tapir_Schema(this$1);
    this.Lapp_data_GeneralPracticeUserRole$__f_schemabitmap$1 = true;
  }
  return this.Lapp_data_GeneralPracticeUserRole$__f_schema$lzy1;
});
$c_Lapp_data_GeneralPracticeUserRole$.prototype.circeCodec__Lio_circe_Codec = (function() {
  if ((!this.Lapp_data_GeneralPracticeUserRole$__f_circeCodecbitmap$1)) {
    var this$1 = $m_Lapp_data_GeneralPracticeUserRole$namedEnum$();
    this.Lapp_data_GeneralPracticeUserRole$__f_circeCodec$lzy1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec(this$1);
    this.Lapp_data_GeneralPracticeUserRole$__f_circeCodecbitmap$1 = true;
  }
  return this.Lapp_data_GeneralPracticeUserRole$__f_circeCodec$lzy1;
});
$c_Lapp_data_GeneralPracticeUserRole$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_data_GeneralPracticeUserRole$$anon$1__f__$ordinal$1;
});
var $d_Lapp_data_GeneralPracticeUserRole$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserRole$, "app.data.GeneralPracticeUserRole$", ({
  Lapp_data_GeneralPracticeUserRole$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserRole$ as $d_Lapp_data_GeneralPracticeUserRole$ };
var $n_Lapp_data_GeneralPracticeUserRole$;
function $m_Lapp_data_GeneralPracticeUserRole$() {
  if ((!$n_Lapp_data_GeneralPracticeUserRole$)) {
    $n_Lapp_data_GeneralPracticeUserRole$ = new $c_Lapp_data_GeneralPracticeUserRole$();
  }
  return $n_Lapp_data_GeneralPracticeUserRole$;
}
export { $m_Lapp_data_GeneralPracticeUserRole$ as $m_Lapp_data_GeneralPracticeUserRole$ };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserRole() {
}
export { $c_Lapp_data_GeneralPracticeUserRole as $c_Lapp_data_GeneralPracticeUserRole };
$c_Lapp_data_GeneralPracticeUserRole.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_GeneralPracticeUserRole.prototype.constructor = $c_Lapp_data_GeneralPracticeUserRole;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserRole() {
}
export { $h_Lapp_data_GeneralPracticeUserRole as $h_Lapp_data_GeneralPracticeUserRole };
$h_Lapp_data_GeneralPracticeUserRole.prototype = $c_Lapp_data_GeneralPracticeUserRole.prototype;
$c_Lapp_data_GeneralPracticeUserRole.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_GeneralPracticeUserRole.prototype.has__Lapp_data_GeneralPracticeUserPermission__Z = (function(permission) {
  var x1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), this, permission);
  var x9 = x1.T2__f__1;
  var x10 = x1.T2__f__2;
  var x = $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole();
  if ((x === x9)) {
    if ((x10 instanceof $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024$002dRemove$002dUser.$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser)) {
      var x13 = x10.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role;
      var x$3 = $s_Lapp_data_GeneralPracticeUserRole$__Owner__Lapp_data_GeneralPracticeUserRole();
      if ((x$3 === x13)) {
        return false;
      }
    }
    return true;
  }
  var x$5 = $s_Lapp_data_GeneralPracticeUserRole$__Member__Lapp_data_GeneralPracticeUserRole();
  if ((x$5 === x9)) {
    matchAlts1: {
      matchAlts2: {
        var x$7 = $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024.$s_Lapp_data_GeneralPracticeUserPermission$__ListUsers__Lapp_data_GeneralPracticeUserPermission();
        if (((x$7 === null) ? (x10 === null) : x$7.equals__O__Z(x10))) {
          break matchAlts2;
        }
        var x$9 = $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024.$s_Lapp_data_GeneralPracticeUserPermission$__InviteUser__Lapp_data_GeneralPracticeUserPermission();
        if (((x$9 === null) ? (x10 === null) : x$9.equals__O__Z(x10))) {
          break matchAlts2;
        }
        var x$11 = $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024.$s_Lapp_data_GeneralPracticeUserPermission$__RemovePendingUserInvitation__Lapp_data_GeneralPracticeUserPermission();
        if (((x$11 === null) ? (x10 === null) : x$11.equals__O__Z(x10))) {
          break matchAlts2;
        }
        var x$13 = $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024.$s_Lapp_data_GeneralPracticeUserPermission$__ChangeSettings__Lapp_data_GeneralPracticeUserPermission();
        if (((x$13 === null) ? (x10 === null) : x$13.equals__O__Z(x10))) {
          break matchAlts2;
        }
        if ((x10 instanceof $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission$0024$002dRemove$002dUser.$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser)) {
          break matchAlts2;
        }
        break matchAlts1;
      }
      return false;
    }
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x1);
});
function $isArrayOf_Lapp_data_GeneralPracticeUserRole(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserRole)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserRole as $isArrayOf_Lapp_data_GeneralPracticeUserRole };
var $d_Lapp_data_GeneralPracticeUserRole = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass(0, "app.data.GeneralPracticeUserRole", ({
  Lapp_data_GeneralPracticeUserRole: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserRole as $d_Lapp_data_GeneralPracticeUserRole };
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserRole$$anon$1(\u03b4name$4, _$ordinal$4) {
  this.Lapp_data_GeneralPracticeUserRole$$anon$1__f_$name$1 = null;
  this.Lapp_data_GeneralPracticeUserRole$$anon$1__f__$ordinal$1 = 0;
  this.Lapp_data_GeneralPracticeUserRole$$anon$1__f_$name$1 = \u03b4name$4;
  this.Lapp_data_GeneralPracticeUserRole$$anon$1__f__$ordinal$1 = _$ordinal$4;
}
export { $c_Lapp_data_GeneralPracticeUserRole$$anon$1 as $c_Lapp_data_GeneralPracticeUserRole$$anon$1 };
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype = new $h_Lapp_data_GeneralPracticeUserRole();
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.constructor = $c_Lapp_data_GeneralPracticeUserRole$$anon$1;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserRole$$anon$1() {
}
export { $h_Lapp_data_GeneralPracticeUserRole$$anon$1 as $h_Lapp_data_GeneralPracticeUserRole$$anon$1 };
$h_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype = $c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype;
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lapp_data_GeneralPracticeUserRole$$anon$1__f_$name$1;
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.toString__T = (function() {
  return this.Lapp_data_GeneralPracticeUserRole$$anon$1__f_$name$1;
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_data_GeneralPracticeUserRole$$anon$1__f_$name$1);
});
$c_Lapp_data_GeneralPracticeUserRole$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_GeneralPracticeUserRole$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserRole$$anon$1, "app.data.GeneralPracticeUserRole$$anon$1", ({
  Lapp_data_GeneralPracticeUserRole$$anon$1: 1,
  Lapp_data_GeneralPracticeUserRole: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_GeneralPracticeUserRole$$anon$1 as $d_Lapp_data_GeneralPracticeUserRole$$anon$1 };
var $t_Lapp_data_GeneralPracticeUserRole$__Owner = null;
function $u_Lapp_data_GeneralPracticeUserRole$__Owner(x) {
  $t_Lapp_data_GeneralPracticeUserRole$__Owner = x;
}
export { $t_Lapp_data_GeneralPracticeUserRole$__Owner as $t_Lapp_data_GeneralPracticeUserRole$__Owner, $u_Lapp_data_GeneralPracticeUserRole$__Owner as $u_Lapp_data_GeneralPracticeUserRole$__Owner };
var $t_Lapp_data_GeneralPracticeUserRole$__Member = null;
function $u_Lapp_data_GeneralPracticeUserRole$__Member(x) {
  $t_Lapp_data_GeneralPracticeUserRole$__Member = x;
}
export { $t_Lapp_data_GeneralPracticeUserRole$__Member as $t_Lapp_data_GeneralPracticeUserRole$__Member, $u_Lapp_data_GeneralPracticeUserRole$__Member as $u_Lapp_data_GeneralPracticeUserRole$__Member };
//# sourceMappingURL=app.data.-General-Practice-User-Role.js.map
